import dayjs from 'dayjs'

import { ClassifiedInstallationBlock } from '../../rest/types/Classified'

export function BlockInstallationTransformer({
  block,
  t,
}: {
  block: ClassifiedInstallationBlock
  t: any
}) {
  return {
    texts: {
      seeLess: t('ads_types_see_less'),
      seeMore: t('ads_types_see_more'),
    },
    ...((block?.specialities ||
      block?.cabinetType ||
      block?.offerType ||
      block?.secretariats) && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.offerType
            ? [
                {
                  title: t('ads_types_offer_type_title'),
                  text: block?.offerType?.name,
                },
              ]
            : []),

          ...(block?.cabinetType
            ? [
                {
                  title: t('ads_types_cabinet_type_title'),
                  text: block?.cabinetType?.name,
                },
              ]
            : []),
          ...(block?.secretariats
            ? [
                {
                  title: t('ads_types_secretariat_type_title'),
                  texts: block?.secretariats.map((item) => item.name),
                },
              ]
            : []),
          ...(block?.specialities
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  texts: block?.specialities?.map((item) => item.name),
                },
              ]
            : []),
        ],
      },
    }),
    ...(block?.startDate && {
      adsDetails: {
        items: [
          {
            label: t('ads_details_installation_date_title'),
            value: dayjs(block?.startDate).format('DD MMMM YYYY'),
          },
        ],
      },
    }),
  }
}
